import moment from "moment";

export const calculateExpiry = (expiration_date) => {
  const today = moment(); // Current date
  const expirationDate = moment(expiration_date); // Convert expiration date to moment

  const diffInDays = today.diff(expirationDate, "days");
  const diffInMonths = today.diff(expirationDate, "months");

  // Return the difference in days or months
  if (Math.abs(diffInMonths) > 0) {
    return `${Math.abs(diffInMonths)} month${
      Math.abs(diffInMonths) === 1 ? "" : "s"
    }`;
  } else if (Math.abs(diffInMonths) === 0) {
    return `${Math.abs(diffInDays)} day${
      Math.abs(diffInDays) === 1 ? "" : "s"
    } `;
  } else return;
};

export const getUserId = () => {
  const userId = localStorage.getItem("jobUserId");
  return userId;
};
